module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0106.jpg?v=93a6e770";